import './Footer.css';
import white from "../../Photos/LaptopLogoW.png"
import black from "../../Photos/LaptopLogoBK.png"

function Footer({ darkMode }) {
    return (
        <footer className={darkMode ? "Footer-dark" : "Footer"} id="footer">
            <div className="footer-content">
                <div className="footer-header">
                    <img src={darkMode ? white : black} alt="OA" />
                    <p>Oluwafisayo Adabonyan</p>
                </div>
                <div className="footer-links">
                    <h3>
                        <a href="mailto:fisayoadabs@gmail.com">
                            <i class="fa fa-envelope"></i>
                        </a>
                    </h3>
                    <h3>
                        <a href="https://www.linkedin.com/in/oluwafisayo-adabs-/">
                            <i class="fa fa-linkedin"></i>
                        </a>
                    </h3>
                    <h3>
                        <a href="https://www.github.com/fisayoadabs">
                            <i class="fa fa-github"></i>
                        </a>
                    </h3>
                </div>
                <span className="copyright">
                    © {new Date().getFullYear()} Oluwafisayo Adabonyan.
                    All Rights Reserved
                </span>
            </div>
        </footer>
    );
}
export default Footer;
